export const SET_AUTH_DATA = "SET_AUTH_DATA";
export const USER_AUTHENTICATED = "USER_AUTHENTICATED";
export const FORCE_CHANGE_PASSWORD = "FORCE_CHANGE_PASSWORD";
export const MFA_CONFIRMATION_REQUIRED = "MFA_CONFIRMATION_REQUIRED";
export const USER_INFO = "USER_INFO";
export const USER_SIGNOUT = "USER_SIGNOUT";
export const SETUP_TOTP = "SETUP_TOTP";
export const TOTP_COMPLETE = "TOTP_COMPLETE";
export const SET_SIGNUP_DATA = "SET_SIGNUP_DATA";
export const SET_SIGNUP_FORM_DATA = "SET_SIGNUP_FORM_DATA";
export const RESET_SIGNUP_FORM_DATA = "RESET_SIGNUP_FORM_DATA";

const initialState = {
  authLoading: true, // initial status that indicates user checking is executed
  passwordResetLinkValidation: true,
  profileUpdateBtnDisable: false,
  passwordUpdateBtnDisable: false,
  tokenVetificationStatus: "LOADING",
  verifyingUserName: "",
  otp_verify: false,
  smas_mfa_auth_otp: true,
  change_password_otp_popup: false,
  change_password_otp: "",
  change_password_resend: true,
  change_password_disable: false,
  mobile_number_add: false,
  document_url:
    "https://glu-dev-images.s3.ap-south-1.amazonaws.com/public/logo/GLU+Horizon+EULA.pdf",

  myplanReadAccess: true,
  myplanAllAccess: true,
  myOrgReadAccess: true,
  myOrgAllAccess: true,
  myProfileReadAccess: true,
  myProfileAllAccess: true,
  myTeamReadAccess: true,
  myTeamAllAccess: true,
  settingsReadAccess: true,
  settingsAllAccess: true,
  adoptReadAccess: true,
  adoptAllAccess: true,
  purchaseReadAccess: true,
  purchaseAllAccess: true,
  dashboardReadAccess: true,
  channelPartnersReadAccess: true,
  channelPartnersAllAccess: true,
  billingDetailsReadAccess: true,
  billingDetailsAllAccess: true,
  stripePlansReadAccess: true,
  stripePlansAllAccess: true,
  planPurchasedReadAccess: true,
  planPurchasedAllAccess: true,
  addCardReadAccess: true,
  addCardAllAccess: true,
  invoiceReadAccess: true,
  invoiceAllAccess: true,
  allPaidActivePlans: [],
  monthlyPlan: false,
  mainSubscribeId: null,
  accessModules: [],
  moduleActivateAccess: false,
  moduleAdoptAccess: false,
  modulePurchaseAccess: false,
  moduleKycAccess: false,
  moduleReuseAccess: false,
  moduleAdoptMyplanAccess: false,
  moduleActivateMyplanAccess: false,
  subMainpageAccess: true,
  onTrail: false,
  trailDayCount: 0,
  //kyc session
  kycModuleReadAccess: true,
  moduleRenewalAccess: false,
  renewalModuleReadAccess: true,
  //kyc end

  netPulseReadAccess: true,
  netPulseAllAccess: false,

  iSightReadAccess: true,
  iSightAllAccess: false,

  loaModuleReadAccess: false,
  loaModuleAllAccess: false,

  //opportunity

  opportunityReadAccess: true,
  opportunityAllAccess: false,

  activeDealsReadAccess: true,
  activeDealsAllAccess: false,

  csmFocusReadAccess: true,
  csmFocusAllAccess: false,

  psCalculatorReadAccess: true,
  psCalculatorAllAccess: false,

  siteInABoxReadAccess: true,
  siteInABoxAllAccess: false,

  reuseReadAccess: true,
  reuseAllAccess: false,

  //signUp
  drop_down_country_of_operations: "",
  drop_down_regions: "",
  drop_down_Languages: "",
  drop_down_organisation_types: "",
  disable_submit_button: false,
  resetUserSignUpForm: {
    new_user_org_name: "",
    new_user_email: "",
    new_user_contact_person_name: "",
    new_user_phone_number: "",
    new_user_region_id: "",
    new_user_country_operation_id: "",
    new_user_language_id: "",
    cx_specialized: "none",
  },
  requestBody: {
    new_user_org_name: "",
    new_user_email: "",
    new_user_contact_person_name: "",
    new_user_phone_number: "",
    new_user_region_id: "",
    new_user_country_operation_id: "",
    new_user_language_id: "",
    cx_specialized: "none",
  },
  walletBalance: 0,
  kycReportLoading: true,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_AUTH_DATA:
      return { ...state, ...action.payload };
    case USER_AUTHENTICATED: {
      return {
        ...state,
        authenticated: true,
        changePassword: false,
        mfa: false,
        temp_user_info: {},
        user: action.payload,
      };
    }
    case MFA_CONFIRMATION_REQUIRED: {
      return {
        ...state,
        authenticated: false,
        mfa: true,
        changePassword: false,
        ...action.payload,
      };
    }
    case FORCE_CHANGE_PASSWORD: {
      return {
        ...state,
        authenticated: false,
        mfa: false,
        changePassword: true,
        ...action.payload,
      };
    }
    case USER_INFO: {
      return {
        ...state,
        authenticated: true,
        authLoading: false,
        ...action.payload,
      };
    }
    case USER_SIGNOUT: {
      return {
        ...state,
        authenticated: false,
        mfa: false,
        temp_user_info: {},
        user: {},
        profile: {},
        passwordAttempts: 0,
      };
    }
    case SETUP_TOTP: {
      return {
        ...state,
        totp_popup: true,
        totp_connection_string: action.payload,
      };
    }
    case TOTP_COMPLETE: {
      return { ...state, totp_popup: false, totp_connection_string: "" };
    }
    case SET_SIGNUP_DATA: {
      return { ...state, ...action.payload };
    }
    case SET_SIGNUP_FORM_DATA: {
      return {
        ...state,
        requestBody: {
          ...state.requestBody,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    case RESET_SIGNUP_FORM_DATA: {
      return { ...state, requestBody: initialState.resetUserSignUpForm };
    }
    default:
      return state;
  }
};
